import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const StatusWrapper = styled.div`
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${tokens.spacing.insetXsmall};
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
`

export const StatusOttoWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%) rotate(-5.906deg);
  }
`

export const Description = styled.p`
  margin: 0;
  color: ${tokens.colors.dark5};
  font-size: ${tokens.fontSize.small};
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${tokens.spacing.verticalSmall};
  margin-top: ${tokens.spacing.verticalXlarge};
`
